module.exports = __webpack_public_path__ + "img/monoxid-sensor-lg.a8c933b7.svg";